import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private apiEndpoint = API_ENDPOINTS;

  constructor(
    private http: HttpClient
  ) { }

  getLoggedInUserPermissions(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint.permission, data);
  }
}
